import React, { useState, useEffect, useRef, useContext } from 'react';
import { StoreContext } from '../../store';
import './index.css';

import { Rating } from 'react-simple-star-rating';
import ClickOutsideHandler from '../../utility/ClickOutsideHandler';


import WalkingTimeDistance from '../../assets/landing-page/walking-time-distance.svg';
import WalkingTimeDistance2 from '../../assets/landing-page/walking-time-distance-2.png';
import { ReactComponent as MeasureArrow } from '../../assets/landing-page/wwm/arrow.svg';

import Banner from '../../assets/home-page/banner.png';

import { ReactComponent as Play } from '../../assets/play-icon.svg';
import { ReactComponent as CloseIcon } from '../../assets/cancel-white.svg';

import BannerVideo from '../../assets/home-page/home-video.mp4';

import {
  walkIndexFeatures,
  lifeStyleFeatures,
  partnersData,
  otherFeatures,
  impactData,
  neighborhoodIntelTabs,
  neighborhoodSearchFeatures,
  measureSlideData,
  testimonialsData,
} from '../../constants';

import { fetchPlaceDetails } from '../../api';
import { saveAddressToRecentlyViewed, debounce, scrollToTop } from '../../services';

import Slider from 'react-slick';
import Show from '../../utility/Show';

const Home = () => {
  const { state, actions, dispatch, navigate } = useContext(StoreContext);
  const { isGoogleMapsLoaded, isMobile, recentlyViewedAddresses, currentCity } = state;
  const [currentTab, setCurrentTab] = useState(0);
  const [measureTab, setMeasureTab] = useState(0);
  const [predictions, setPredictions] = useState([]);
  const [showIframe, setShowIframe] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const inputRef = useRef();
  let sliderRef = useRef(null);
  let measureSliderRef = useRef(null);
  const iframeRef = useRef(null);
  const placeholderRef = useRef(null);

  const NeighborhoodIntelTabs = () => {
    const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      swipe: false,
      adaptiveHeight: isMobile ? true : false,
    };

    const handleTabClick = (index) => {
      setCurrentTab(index);
    };

    useEffect(() => {
      if (sliderRef) {
        sliderRef.slickGoTo(currentTab);
      }
    }, [currentTab]);

    return (
      <div className='neighborhood-intel-tabs'>
        <h1 className='landing-title 2xs:text-xl'>YOUR NEIGHBORHOOD RECOMMENDATION SYSTEM</h1>
        <div className='tabs'>
          {neighborhoodIntelTabs.map((tab, index) => (
            <div
              key={index}
              className={`tab ${currentTab === index ? 'active' : ''}`}
              onClick={() => handleTabClick(index)}
            >
              {tab.name}
            </div>
          ))}
        </div>
        <Slider
          ref={(slider) => {
            sliderRef = slider;
          }}
          {...settings}
        >
          {neighborhoodIntelTabs.map((tab, index) => (
            <div
              key={index}
              className={`tab-content ${tab.name === 'Scoring' && 'scoring'}`}
            >
              <Show>
                <Show.When isTrue={tab.name === 'Scoring'}>
                  <img src={tab.img1} alt={tab.name} />
                  <img src={tab.img2} alt={tab.name} />
                </Show.When>
                <Show.Else>
                  <img src={tab.img} alt={tab.name} />
                </Show.Else>
              </Show>
            </div>
          ))}
        </Slider>
      </div>
    );
  };

  const searchAddress = () => {
    if (isGoogleMapsLoaded) {
      const autocompleteService =
        new window.google.maps.places.AutocompleteService();
      if (autocompleteService && inputRef.current) {
        const inputText = inputRef.current.value;
        const city = currentCity ? `${currentCity}, ` : '';

        autocompleteService.getPlacePredictions(
          {
            input: city + inputText,
            types: ['geocode'], // You can specify the types of predictions you want
          },
          async (predictions, status) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
              try {
                // Fetch details for each prediction
                const detailedPredictions = await Promise.all(predictions.map(async (prediction) => {
                  try {
                    const details = await fetchPlaceDetails(prediction.place_id);
                    return {
                      ...prediction,
                      latitude: details.geometry.location.lat(),
                      longitude: details.geometry.location.lng(),
                    };
                  } catch (error) {
                    console.error(`Failed to fetch details for place_id ${prediction.place_id}:`, error);
                    return null;
                  }
                }));

                // Filter out any null results (in case some place details couldn't be fetched)
                const validPredictions = detailedPredictions.filter(prediction => prediction !== null);
                setPredictions(validPredictions);
              } catch (error) {
                console.error('Error fetching place details:', error);
                setPredictions([]);
              }
            } else {
              setPredictions([]);
            }
          }
        );
      }
    }
  };

  const replaceWithDashes = (str) => {
    // Replace non-alphanumeric characters with dashes
    let result = str.replace(/[^a-zA-Z0-9]/g, '-');
    // Replace multiple consecutive dashes with a single dash
    result = result.replace(/-+/g, '-');
    // Remove leading and trailing dashes if any
    result = result.replace(/^-|-$/g, '');
    return result;
  };

  const addressClick = async (address) => {
    actions.handleLogin();
    // actions.sendDataToGoogleAnalytics('used_address_search', {});
    // dispatch({ type: 'SET_SHOW_SEARCH_ADDRESS', payload: false });
    const data = await actions.fetchAddressData(address.description, false, true)

    saveAddressToRecentlyViewed(data, recentlyViewedAddresses, dispatch);

    dispatch({ type: 'SET_LOADING', payload: true });
    // await actions.fetchAddressData(address);
    // navigate(`/address/${replaceWithDashes(address.description)}`);
    const newAddress = `address/${replaceWithDashes(address.description)}`;
    const baseUrl = window.location.origin;
    window.location.replace(`${baseUrl}/${newAddress}`);
  };

  const handleSearchChange = (event) => {
    if (!event.target.value) {
      setPredictions([]);
    } else {
      searchAddress();
    }
  };

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          actions.handleLogin();
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
          actions.fetchAddressByLatLng(lat, lng);
          navigate(`/plugin`);
        },
        (error) => {
          console.log(error);
        }
      );
    } else {
      console.log('Geolocation is not supported by this browser.');
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setShowIframe(false);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 } // Adjust this value as needed
    );

    if (placeholderRef.current) {
      observer.observe(placeholderRef.current);
    }

    document.title = 'Home - Walkspan';

    return () => {
      if (placeholderRef.current) {
        observer.unobserve(placeholderRef.current);
      }
    };
  }, []);

  const handleLoadFrame = () => {
    setTimeout(() => {
      setShowIframe(true);
    }, 1000);
  };

  const bannerFeatures = [
    {
      title: "Real Estate",
      description: "seamless integration of neighborhood search with property search",
      url: '/services/real-estate'
    },
    {
      title: "Travel",
      description: "displays neighborhood gems in every destination",
      url: '/services/travel'
    },
    {
      title: "20-min city",
      description: "we shrink the city to a 5-10-20 minute walking radii",
      url: '/services/20-min-city'
    },
  ];

  const HomeBanner = () => {
    const gotoContactUs = () => {
      scrollToTop();
      navigate('/contact-us');
      document.title = 'Contact Us - Walkspan';
    };

    const handleShowVideo = () => {
      setShowVideo(!showVideo);
    };

    return (
      <div className='home-banner'>
        <Show.When isTrue={true}>
          <img
            ref={placeholderRef}
            className='banner-placeholder'
            src={Banner}
            alt='Loading video...'
          />
        </Show.When>
        <Show.When isTrue={showVideo}>
          <div className="fixed top-0 left-0 w-full !h-[100svh] bg-black bg-opacity-80 flex justify-center items-center z-50">
            <CloseIcon className='absolute top-4 right-4 h-5 w-auto cursor-pointer' />
            <ClickOutsideHandler onOutsideClick={() => handleShowVideo()}>
              <iframe
                width="100%"
                height="auto"
                src="https://player.vimeo.com/video/1058236664?h=b756f18907&badge=0&autopause=0&player_id=0&app_id=58479&byline=0&portrait=0&title=0&ui=0"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                className="rounded-lg 2xs:w-[80svw] md:w-[100svw] 2xs:h-[25svh] md:h-[50svh]"
              ></iframe>
            </ClickOutsideHandler>
          </div>
        </Show.When>
        <div className='max-w-screen-lg'>
          <div className='banner-content '>
            <div className='text-2xl 2xs:text-xl lg:text-5xl drop-shadow-2xl font-medium'>Neighborhood Intelligence</div>
            <span className='text-xl lg:text-[28px]'> Your neighborhood, your street, your story </span>
            {/* <div className='search-address-input'>
              <div
                onClick={() => getLocation()}
                className='current-location-icon'
              >
                <Target />
              </div>
              <input
                ref={inputRef}
                onChange={(e) => handleSearchChange(e)}
                placeholder='Search for an address, location , cities ...'
              />
              <div className='modern-search-address-btn'>
                <Search />
              </div>
              <Show>
                <Show.When isTrue={predictions.length !== 0}>
                  <div
                    className={`prediction-container ${
                      currentView === 'Modern' && 'modern-prediction-container'
                    }`}
                  >
                    {predictions.map((prediction) => (
                      <div
                        className='prediction'
                        key={prediction.place_id}
                        onClick={() => addressClick(prediction)}
                      >
                        {prediction.description}
                      </div>
                    ))}
                  </div>
                </Show.When>
              </Show>
            </div> */}
            <div className='features px-4 py-5 mt-4 2xs:m-4 w-full 2xs:max-w-[365px] md:max-w-[850px]'>
              {bannerFeatures.map((feature) => (
                <a href={feature.url} className='item flex flex-col gap-2 px-5 pl-8 py-5 text-left border-l-2 border-white w-full h-full'>
                  <div className='lg:text-xl text-[16px] font-medium 2xs:pl-2 md:p-0'>{feature.title}</div>
                  <div className='text-[14px] 2xs:pl-2 md:p-0'>{feature.description}</div>
                </a>
              ))}
            </div>
            <div className='flex 2xs:flex-col md:flex-row gap-2'>
              <div
                className='req-demo w-auto p-4 text-xl rounded-md cursor-pointer hover:!bg-white hover:text-black flex gap-2 items-center'
                onClick={() => handleShowVideo()}
              >
                <Play className='!h-[20px] w-auto' /> Watch our video
              </div>
              <div
                className='req-demo w-auto p-4 text-xl rounded-md cursor-pointer hover:!bg-white hover:text-black'
                onClick={() => gotoContactUs()}
              >
                Request a Demo
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const NeighborhoodSearch = () => {
    return (
      <div className='home-neighborhood-search'>
        <div className='max-w-screen-lg'>
          <div className='title'>neighborhood search</div>
          <div className='ns-features'>
            {neighborhoodSearchFeatures.map((feature, index) => (
              <div>
                <div className='ns-feature-title'>{feature.name}</div>
                <div className='ns-feature-desc'>{feature.description}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  const Measurements = () => {
    const settings = {
      infinite: false,
      dots: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipe: false,
    };

    const handleArrowClick = (index, type) => {
      if (
        (type === 'plus' && measureTab !== 9) ||
        (type === 'minus' && measureTab !== 0)
      ) {
        debounce(setMeasureTab(index), 2000);
      }
    };

    useEffect(() => {
      if (measureSliderRef) {
        measureSliderRef.slickGoTo(measureTab);
      }
    }, [measureTab]);

    return (
      <div className='measurements-container'>
        <div className='max-w-screen-lg relative'>
          <h1 className='text-xl md:text-3xl uppercase font-medium mb-4'>What We Measure</h1>
          <Slider
            ref={(slider) => {
              measureSliderRef = slider;
            }}
            {...settings}
          >
            {measureSlideData.map((tab, index) => (
              <div key={index} className='!flex justify-between items-start flex-col md:flex-row py-8'>
                <div className='relative flex flex-col text-left gap-4'>
                  <div className='-z-2 absolute text-gray-300 font-bold text-6xl md:text-8xl number 2xs:-top-[8px] md:top-0'>0{index+1}</div>
                  <div className='2xs:mt-7 md:mt-9 z-10'>
                    <div className='uppercase font-bold 2xs:text-4xl md:text-5xl'>{tab.title}</div>
                    <div className='text-[14px] 2xs:text-3xl md:text-2xl font-medium max-w-[350px]'>{tab.subtitle}</div>
                  </div>
                  <div className='italic font-medium description text-[16px]'>{tab.description}</div>
                </div>
                <img
                  src={tab.img}
                  className='w-[450px] h-[400px] object-contain 2xs:mt-2 md:m-0'
                  alt={`measure-img-${index+1}`}
                />
              </div>
            ))}
          </Slider>
          <div className='arrow-wrapper'>
            <MeasureArrow
              className='arrow'
              onClick={() => handleArrowClick(measureTab - 1, 'minus')}
            />
            <MeasureArrow
              className='arrow -scale-x-100'
              onClick={() => handleArrowClick(measureTab + 1, 'plus')}
            />
          </div>
        </div>
      </div>
    );
  };

  const OtherFeatures = () => {
    return (
      <section className='other-features'>
        <div className='max-w-screen-lg'>
          <h1 className='landing-title'>Other Features</h1>
          <div className='features-list'>
            {otherFeatures.map((feature, index) => (
              <div key={index} className='other-feature-item'>
                <Show>
                  <Show.When isTrue={feature.name === 'Ratings'}>
                    <Rating
                      className='ratings-icon'
                      initialValue={4}
                      iconsCount={5}
                      fillColor='#FFFFFF'
                      readonly
                    />
                  </Show.When>
                  <Show.Else>{feature.img}</Show.Else>
                </Show>
                <p>{feature.name}</p>
              </div>
            ))}
          </div>

          <button className='landing-view-btn'>Explore all features</button>
        </div>
      </section>
    );
  };

  const ImpactStartup = () => {
    return (
      <section className='impact-startup max-w-screen-lg'>
        <h1 className='landing-title'>WALKSPAN IS AN IMPACT STARTUP</h1>
        <div className='description'>
          Our business is designed to solve environmental and societal problems.
          Buying homes where lifestyle essentials are within walking reach will
          generate positive sustainable impacts.
        </div>
        <div className='impact-list'>
          {impactData.map((impact, index) => (
            <div key={index} className='impact-item'>
              <img src={impact.img} alt='Impact' />
              <p>{impact.description}</p>
            </div>
          ))}
        </div>
      </section>
    );
  };

  const Partners = () => {
    return (
      <section className='partners'>
        <div className='max-w-screen-lg'>
          <h1 className='landing-title'>Our Partners</h1>
          <div className='partners-list'>
            {partnersData.map((partner, index) => (
              <div key={index} className='partner-item'>
                <img src={partner.img} alt={partner.name} />
                <h3>{partner.name}</h3>
                <p>{partner.description}</p>
                <a
                  href={partner.link}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='landing-view-btn'
                >
                  Visit Website
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  };

  const Testimonials = () => {
    return (
      <div className='testimonials-wrapper'>
          <div className='max-w-screen-lg relative'>
            <h1 className='2xs:text-xl md:text-3xl uppercase lg:mb-16 mb-8'>Testimonials</h1>
            <div className='flex 2xs:flex-col md:flex-row gap-6 mb-12'>
              {testimonialsData.map((data, index) => (
                <div className='flex flex-col items-center'>
                  <img src={data.img} alt={`testimonila-${index+1}`} />
                  <div className='mt-2 font-medium'>{data.name}</div>
                  <div className='text-sm font-light mb-6 text-gray-400'>{data.title}</div>
                  <div className='mt-2 2xs:my-2 text-sm italic'>“{data.msg}”</div>
                </div>
              ))}
            </div>
            {/* <div className='rounded bg-white text-black w-fit mx-auto py-2 px-6 font-medium cursor-pointer'>
              View all
            </div> */}
          </div>
      </div>
    )
  };

  return (
    <div className='landing-home-container'>
      {HomeBanner()}
      {/* {NeighborhoodSearch()} */}
      {NeighborhoodIntelTabs()}
      <div className='w-full bg-[#211F1F] lg:py-16'>
        <div className='relative max-w-screen-xl mx-auto overflow-hidden'>
          <img src={isMobile ? WalkingTimeDistance2 : WalkingTimeDistance} className='walking-td' />
          <div className='absolute 2xs:top-8 md:top-1/2 2xs:right-1/2 md:right-5 transform 2xs:translate-x-1/2 md:translate-x-0 2xs:-translate-y-0 md:-translate-y-1/2 text-white p-4 rounded-lg max-w-full lg:max-w-[40%] 2xs:w-full md:w-[unset]'>
            <h2 className='2xs:text-2xl md:text-4xl font-medium mb-2 shadow-lg uppercase'>Walking <br/> Time and Distance</h2>
            <span className='text-[14px] md:text-2xl leading-none lg:leading-relaxed shadow-md'>Walkspan is the only AI-driven intelligence platform that provides a comprehensive overview of a neighborhood and the ability to examine each of the factors individually and within walkable distances from specific addresses.</span>
          </div>
        </div>
      </div>
   
      {Measurements()}
      {Testimonials()}
      {/* {OtherFeatures()} */}
      {/* <main>
        {ImpactStartup()}
        {Partners()}
      </main> */}
    </div>
  );
};

export default Home;
